/**
 * เส้นทางของใบเสนอราคา — หน้าเต็มตั้งแต่ 28 ต.ค. 2026 (มติ PO: ดู/แก้ไขทั้งใบเป็นหน้าเต็มแทนโมดัล)
 *   /billing/quotations            รายการ (quotations.view)
 *   /billing/quotations/:id        รายละเอียด (quotations.view)
 *   /billing/quotations/new        สร้างใหม่ (quotations.create)
 *   /billing/quotations/:id/edit   แก้ไข (quotations.view + quotations.edit · ใบร่างเท่านั้น)
 * ลิงก์เก่า `?open=<id>` / `?view=<id>` / `?edit=<id>` บนหน้ารายการ → เด้งไปหน้าเต็ม (QuotationLegacyRedirect)
 *
 * เดิม (30 ก.ย. 2026 SB-08) `/:id` render หน้ารายการแล้วเปิดโมดัลทับ — ถอดทิ้งพร้อมการซิงก์ history ของโมดัล
 */

export const QUOTATION_LIST_PATH = '/billing/quotations';
export const QUOTATION_NEW_PATH = `${QUOTATION_LIST_PATH}/new`;

/** path รายละเอียดของใบ (id ผ่านการตรวจมาแล้วจากผู้เรียก) */
export const quotationDetailPath = (id: number | string): string => `${QUOTATION_LIST_PATH}/${id}`;

/** path หน้าแก้ไขของใบ */
export const quotationEditPath = (id: number | string): string => `${QUOTATION_LIST_PATH}/${id}/edit`;
